import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Modal, Form } from "react-bootstrap";
import { ButtonComponent, AnchorComponent } from "../elements";
import axios from "axios";
import Select from "react-select";
import { encode } from "base-64";
import { API_URL, APP_PREFIX_PATH, getApiMessage } from "../../constant/constant";
import PaginationComponent from "../PaginationComponent";
import { Row, Col } from "react-bootstrap";
import LabelFieldComponent from "../fields/LabelFieldComponent";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import categoryImage from "../../assets/img/category.webp";

export default function ServiceTableComponent({ thead, tbody }) {
  const { t, currentLanguage } = useContext(TranslatorContext);
  const langCode = currentLanguage?.code || "en";
  const [ServiceDetails, setServiceDetails] = useState([]);

  const [Error, setError] = useState("");
  const [DeleteId, setDeleteId] = useState("");

  const [userData, setUserData] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [AddModal, setAddModal] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [successModel, setsuccessModel] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [AddService, setAddService] = useState("");
  const [AddServiceArabic, setAddServiceArabic] = useState("");
  const [addImage, setaddImage] = useState("");
  const [EditService, setEditService] = useState("");
  const [EditServiceArabic, setEditServiceArabic] = useState("");
  const [EditImage, setEditImage] = useState("");
  const [EditId, setEditId] = useState("");

  const [AddServiceError, setAddServiceError] = useState("");
  const [AddServiceArabicError, setAddServiceArabicError] = useState("");
  const [addImageError, setaddImageError] = useState("");
  const [EditServiceError, setEditServiceError] = useState("");
  const [EditServiceArabicError, setEditServiceArabicError] = useState("");
  const [EditImageError, setEditImageError] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [saveEditLoading, setSaveEditLoading] = useState(false);
  const [addServiceLoading, setAddServiceLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const entriesPerPage = 5;

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;

  const filteredUsers = ServiceDetails.filter((user) => {
    const lowercasedTerm = searchTerm.toLowerCase();
    return (
      user.service_name?.toLowerCase().includes(lowercasedTerm) ||
      user.createtime?.toLowerCase().includes(lowercasedTerm)
    );
  });

  const currentUsers = filteredUsers.slice(indexOfFirstEntry, indexOfLastEntry);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const fetchServiceDetails = () => {
    const user_type = localStorage.getItem("user_type");

    axios
      .post(API_URL + "/fetch_services", { user_type })
      .then((response) => {
        setServiceDetails(response.data.service_arr.reverse() || []);
        // console.log(response.data.service_arr);
      })
      .catch((error) => {
        console.error("Error fetching user details:", error);
      });
  };

  useEffect(() => {
    fetchServiceDetails();
  }, []);

  const handleUserAction = (
    action,
    service_id,
    service_name,
    service_name_arabic
  ) => {
    if (action === "edit") {
      setEditId(service_id);
      setEditService(service_name);
      setEditServiceArabic(service_name_arabic);
    } else if (action === "delete") {
      setAlertModal(true);
      setDeleteId(service_id);
    }
  };

  const DoctorDelete = () => {
    setError("");
    setDeleteLoading(true);
    axios
      .post(API_URL + "/delete_service", { service_id: DeleteId })
      .then((res) => {
        if (!res.data.success) {
          setError(getApiMessage(res.data, langCode) || t("something_went_wrong"));
          return;
        }
        setAlertModal(false);
        fetchServiceDetails();
      })
      .catch((error) => {
        setError(getApiMessage(error.response?.data, langCode) || error.message || t("something_went_wrong"));
        console.error(error);
      })
      .finally(() => setDeleteLoading(false));
  };

  const handleEditService = () => {
    let hasError = false;
    if (!EditService || EditService.trim() == "") {
      setEditServiceError(t("enter_service_name"));
      hasError = true;
    }
    if (!EditServiceArabic || EditServiceArabic.trim() == "") {
      setEditServiceArabicError(t("enter_service_name_arabic"));
      hasError = true;
    }

    if (hasError) {
      return;
    }

    const formData = new FormData();
    formData.append("service_id", EditId);
    formData.append("service_name", EditService);
    formData.append("service_name_arabic", EditServiceArabic);
    formData.append("service_image", EditImage);

    setError("");
    setSaveEditLoading(true);
    axios
      .post(API_URL + "/edit_service", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (!response.data.success) {
          setError(getApiMessage(response.data, langCode) || t("service_already_exist"));
          return;
        }
        setEditModal(false);
        fetchServiceDetails();
      })
      .catch((error) => {
        setError(getApiMessage(error.response?.data, langCode) || error.message || t("something_went_wrong"));
        console.error("Error updating service:", error);
      })
      .finally(() => setSaveEditLoading(false));
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // add doctor
  const handleAddService = () => {
    let hasError = false;
    if (!AddService || AddService.trim() == "") {
      setAddServiceError(t("placeholder_enter_service_name"));
      hasError = true;
    }
    if (!AddServiceArabic || AddServiceArabic.trim() == "") {
      setAddServiceArabicError(t("placeholder_enter_service_arabic"));
      hasError = true;
    }

    if (!addImage) {
      setaddImageError(t("upload_image"));
      hasError = true;
    }

    if (hasError) {
      return;
    }

    const formData = new FormData();
    formData.append("service_name", AddService);
    formData.append("service_name_arabic", AddServiceArabic);

    formData.append("service_image", addImage);

    setError("");
    setAddServiceLoading(true);
    axios
      .post(API_URL + "/add_service", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (!response.data.success) {
          setError(getApiMessage(response.data, langCode) || t("service_already_exist"));
          return;
        }
        setAddModal(false);
        fetchServiceDetails();
        setAddService("");
        setAddServiceArabic("");
        setAddServiceArabicError("");
        setsuccessModel(true);
        setTimeout(() => setsuccessModel(false), 2000);
      })
      .catch((error) => {
        setError(getApiMessage(error.response?.data, langCode) || error.message || t("something_went_wrong"));
        console.error("Error adding service:", error);
      })
      .finally(() => setAddServiceLoading(false));
  };

  return (
    <>
      <Row
        xs={1}
        sm={2}
        xl={4}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Col>
          <LabelFieldComponent
            type="search"
            // label={t('search_by')}
            icon="Search"
            placeholder={`${t("search_here")}`}
            labelDir="label-col"
            fieldSize="mb-4 w-100 h-md"
            value={searchTerm}
            onChange={handleSearch}
          />
        </Col>
        <Col style={{ textAlign: "right", marginBottom: "5px" }}>
          <button
            style={{
              background: "#2b77e5",
              padding: "7px 13px",
              color: "#fff",
              borderRadius: "5px",
            }}
            onClick={() => setAddModal(true)}
          >
            {" "}
            <AddIcon className="me-2" /> {t("add_service")}{" "}
          </button>
        </Col>
      </Row>

      <div className="mc-table-responsive">
        <table className="mc-table">
          <thead className="mc-table-head primary">
            <tr>
              <th>
                <div className="mc-table-check">
                  <p>{t("sno")}</p>
                </div>
              </th>
              <th>{t("actions")}</th>
              <th>{t("image")}</th>
              <th>{t("service_name")}</th>
              <th>{t("service_arabic")}</th>
              <th>{t("createtime")}</th>
            </tr>
          </thead>
          <tbody className="mc-table-body even">
            {currentUsers?.map((item, index) => (
              <tr key={index}>
                <td title="id">
                  <div className="mc-table-check">
                    <p>{indexOfFirstEntry + index + 1}</p>
                  </div>
                </td>
                <td>
                  <div className="mc-table-action">
                    {/* <AnchorComponent to={`${APP_PREFIX_PATH}/doctor-view/${encode(item.doctor_id)}`} title="View" className="material-icons view">visibility</AnchorComponent> */}
                    <ButtonComponent
                      title="Edit"
                      className="material-icons edit"
                      onClick={() => {
                        setEditModal(true, setUserData(item));
                        handleUserAction(
                          "edit",
                          item.service_id,
                          item.service_name,
                          item.service_name_arabic
                        );
                      }}
                    >
                      edit
                    </ButtonComponent>
                    {/* <ButtonComponent title="Block" className="material-icons block" onClick={() => handleUserAction('block', item.user_id, item.active_flag)}>block</ButtonComponent> */}
                    <ButtonComponent
                      type="button"
                      className="material-icons delete"
                      onClick={() =>
                        handleUserAction("delete", item.service_id)
                      }
                    >
                      delete
                    </ButtonComponent>
                  </div>
                </td>
                <td title={item.service_name}>
                  <div className="mc-table-profile">
                    <img
                      src={
                        item.service_image
                          ? `${item.service_image}`
                          : `doctor_placeholder.webp`
                      }
                      alt="Profile"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </td>
                <td>
                  <span>{item.service_name || "NA"}</span>
                </td>
                <td>
                  <span>{item.service_name_arabic || "NA"}</span>
                </td>

                <td>{item.createtime || "NA"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <PaginationComponent
          totalEntries={filteredUsers.length}
          entriesPerPage={entriesPerPage}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />

        <Modal show={editModal} onHide={() => setEditModal(false)}>
          <div className="mc-user-modal">
            <img src={categoryImage} alt="Profile" />
            <h4>{userData?.name}</h4>
            <p>{userData?.email}</p>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("service_name")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("placeholder_enter_service_name")}
                value={EditService}
                onChange={(e) => {
                  setEditService(e.target.value);
                  setEditServiceError("");
                  setError("");
                }}
                maxLength={15}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {EditServiceError}
              </p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("service_arabic")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("placeholder_enter_service_arabic")}
                value={EditServiceArabic}
                onChange={(e) => {
                  setEditServiceArabic(e.target.value);
                  setEditServiceArabicError("");
                  setError("");
                }}
                maxLength={15}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {EditServiceArabicError}
              </p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("image")}</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => {
                  const file = e.target.files[0];
                  setEditImage(file);
                  setEditImageError("");
                }}
              />
              <p style={{ color: "red" }}>{EditImageError}</p>
            </Form.Group>

            <p style={{ color: "red" }}>{Error}</p>
            <Modal.Footer>
              <ButtonComponent
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setEditModal(false);
                  setEditService("");
                  setEditServiceError("");
                  setEditImageError("");
                  setError("");
                }}
              >
                {t("close_popup")}
              </ButtonComponent>
              <ButtonComponent
                type="button"
                className="btn btn-success"
                onClick={handleEditService}
                disabled={saveEditLoading}
              >
                {saveEditLoading ? t("loading") || "Loading..." : t("update")}
              </ButtonComponent>
            </Modal.Footer>
          </div>
        </Modal>

        <Modal
          show={AddModal}
          onHide={() => setAddModal(false)}
          backdrop="static"
        >
          <div className="mc-user-modal">
            <img src={categoryImage} alt="Profile" />
            <h4>{userData?.name}</h4>
            <p>{userData?.email}</p>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("service_name")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("placeholder_enter_service_name")}
                value={AddService}
                onChange={(e) => {
                  setAddService(e.target.value);
                  setAddServiceError("");
                  setError("");
                }}
                maxLength={15}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {AddServiceError}
              </p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("service_arabic")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("placeholder_enter_service_arabic")}
                value={AddServiceArabic}
                onChange={(e) => {
                  setAddServiceArabic(e.target.value);
                  setAddServiceArabicError("");
                  setError("");
                }}
                maxLength={15}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {AddServiceArabicError}
              </p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("image")}</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => {
                  const file = e.target.files[0];
                  setaddImage(file);
                  setaddImageError("");
                }}
              />
              <p style={{ color: "red", textAlign: "left" }}>{addImageError}</p>
            </Form.Group>
            <p style={{ color: "red", textAlign: "left" }}>{Error}</p>

            <Modal.Footer>
              <ButtonComponent
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setAddModal(false);
                  setAddService("");
                  setaddImageError("");
                  setAddServiceError("");
                  setError("");
                  setAddServiceArabicError("");
                }}
              >
                {t("close_popup")}
              </ButtonComponent>
              <ButtonComponent
                type="button"
                className="btn btn-success"
                onClick={handleAddService}
                disabled={addServiceLoading}
              >
                {addServiceLoading ? t("loading") || "Loading..." : t("add")}
              </ButtonComponent>
            </Modal.Footer>
          </div>
        </Modal>

        <Modal show={successModel} onHide={() => setsuccessModel(false)}>
          <div className="mc-alert-modal">
            <i className="material-icons">check_circle</i>
            <h3>{t("success")}</h3>
            <br />
            <p>{t("added_category")}</p>
            <Modal.Footer></Modal.Footer>
          </div>
        </Modal>

        <Modal show={alertModal} onHide={() => !deleteLoading && setAlertModal(false)}>
          <div className="mc-alert-modal">
            <i className="material-icons">new_releases</i>
            <h3>{t("delete_service")}</h3>
            <p>{t("delete_service_details")}</p>
            <Modal.Footer>
              <ButtonComponent
                type="button"
                className="btn btn-secondary"
                onClick={() => setAlertModal(false)}
                disabled={deleteLoading}
              >
                {t("close")}
              </ButtonComponent>
              <ButtonComponent
                type="button"
                className="btn btn-danger"
                onClick={() => DoctorDelete()}
                disabled={deleteLoading}
              >
                {deleteLoading ? t("loading") || "Loading..." : t("delete")}
              </ButtonComponent>
            </Modal.Footer>
          </div>
        </Modal>
      </div>
    </>
  );
}
